import React, { useEffect } from "react";
import Header from "../../../layout/Header";
import Footer from "../../../layout/Footer";
import HeroSection from "../../../layout/HeroSection";
import Listing from "../../lessons/Listing";
import { pageRoutes } from "../../../routes/pageRoutes";
import Loader from "../../../components/other/Loader";
import { fetchFeatherweight } from "../../../redux/action/weightAction";
import { useDispatch, useSelector } from "react-redux";
const Featherweights = () => {
  const dispatch = useDispatch();
  const { featherWeights30lbList, isLoading } = useSelector(
    (state) => state?.weightReducer
  );
 
  useEffect(() => {
    dispatch(fetchFeatherweight());
  }, []);


  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      <div>
        <Header />
        <HeroSection
          label={<h1 class="mb-3">{"Featherweights (30lb.)"}</h1>}
          breadcrumbItems={[
            { name: "Home", path: `${pageRoutes?.home}/` },
            {
              name: "Featherweights (30lb.)",
              path: `${pageRoutes?.home}/`,
            },
          ]}
        />

        <Listing contentData={featherWeights30lbList} />

        <Footer />
      </div>
    </>
  );
};

export default Featherweights;
